import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/signup/")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/login",
      search: search as Record<string, unknown>,
      statusCode: 301,
    });
  },
});
